import { render } from "./CustomerUserDeletePage.vue?vue&type=template&id=492640dc"
import script from "./CustomerUserDeletePage.vue?vue&type=script&lang=js"
export * from "./CustomerUserDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__